import React, {useEffect} from 'react';
import {Card} from '@mui/material';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';
import FormikRemoteAutocompleteField from '../MasterData/components/FormikRemoteAutocompleteField';
import { mastersApi } from '../../../services/MasterDataServices';

export default function CatalogueEntryThree({code, masters}) {
  const {values, setFieldValue} = useFormikContext();

  // Loaders with server-side pagination
  const loadConditions = React.useCallback((params) => mastersApi('conditions', 'get', null, params), []);
  const loadCsrRacks = React.useCallback((params) => mastersApi('csr_racks', 'get', null, params), []);
  const loadPlaceOfOrigins = React.useCallback((params) => mastersApi('place_of_origins', 'get', null, params), []);
  const loadSources = React.useCallback((params) => mastersApi('sources', 'get', null, params), []);

  const commonLabelProps = { style: {fontSize: 14, color: '#929191'}, shrink: true };

  useEffect(() => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      let day = date.getDate();
      day = day < 10 ? `0${day}` : day;
      return `${year}-${month}-${day}`;
    };

    if (values?.date_of_entry) {
      const formattedCompletionDate = formatDate(values.date_of_entry);
      setFieldValue('date_of_entry', formattedCompletionDate);
    }
  }, [values.date_of_entry, setFieldValue]);

  return (
    <Card className={'box-shadow'} sx={{p: 4}}>
      <FormikRemoteAutocompleteField
        name={`translations.${code}.condition`}
        label={'Condition'}
        loadOptions={loadConditions}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.condition`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
      <FormikRemoteAutocompleteField
        name={`translations.${code}.location`}
        label={'Storage Location'}
        loadOptions={loadCsrRacks}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.location`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
      <FormikRemoteAutocompleteField
        name={`translations.${code}.place_of_origin`}
        label={'Place of Origin'}
        loadOptions={loadPlaceOfOrigins}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.place_of_origin`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
      <FormikRemoteAutocompleteField
        name={`translations.${code}.source`}
        label={'Source'}
        loadOptions={loadSources}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.source`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Source Remarks'}
             name={`translations.${code}.source_remarks`} sx={{mt: 1.5}} multiline minRows={2} maxRows={4}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Price'}
             name={`translations.${code}.price`} sx={{mt: 1.5}} type={'number'}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Additional Infomation'}
             name={`translations.${code}.other_info`} sx={{mt: 1.5}} multiline minRows={2.5} maxRows={7}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'}
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Exhibition History'}
             name={`translations.${code}.exhibition_history`} sx={{mt: 1.5}} multiline minRows={2.5} maxRows={7}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Date of Entry'}
             name={'date_of_entry'} sx={{mt: 1.5}} type={'date'}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}